import {
  ContactFragment,
  FinanceFinancialDocumentResourceInput,
  FinanceInvoiceDetailReconciliationFragment,
  FinanceValueObjectsFinancialDocumentTypeEnum,
  FinanceValueObjectsInvoiceStatusEnum,
  FinancialDocumentAssociationFragment,
  FinancialDocumentExpenseFragment,
  FinancialDocumentForSelectFragment,
  FinancialDocumentProjectFragment,
  FinancialDocumentPurchaseOrderFragment,
  FinancialDocumentSubprojectFragment,
  InvoiceFragment,
  JournalDraftEntryFragment,
  JournalEntryFragment,
  LedgerAccountFragment,
  VendorSoftwareSetupFragment,
} from 'generated/resources/graphql'

import { Tax } from 'modules/expenses/hooks/useExpensesCustomization'

export type InvoiceType =
  | InvoiceFragment & {
      reconciliations?: FinanceInvoiceDetailReconciliationFragment[] | []
      vendor?:
        | ((ContactFragment | undefined | null) & {
            softwareSetup?: VendorSoftwareSetupFragment | undefined | null
          })
        | null
      expensesFinancialDocumentAssociation?:
        | (FinancialDocumentAssociationFragment & {
            expense?: FinancialDocumentExpenseFragment | undefined | null
          })
        | null
      purchaseOrderFinancialDocumentAssociation?:
        | (FinancialDocumentAssociationFragment & {
            purchaseOrder?: FinancialDocumentPurchaseOrderFragment | undefined | null
          })
        | null
      softwareSetupFinancialDocumentAssociation?:
        | (FinancialDocumentAssociationFragment & {
            softwareSetup?: VendorSoftwareSetupFragment | undefined | null
          })
        | null
      projectsFinancialDocumentAssociation?:
        | (FinancialDocumentAssociationFragment & {
            financialProject?: FinancialDocumentProjectFragment | undefined | null
          })
        | null
      subprojectsFinancialDocumentAssociation?:
        | (FinancialDocumentAssociationFragment & {
            subproject?: FinancialDocumentSubprojectFragment | undefined | null
          })
        | null
      journalDraftEntry?: JournalDraftEntryFragment | null
      journalEntries?: JournalEntryFragment[] | null
    }

export interface LegalEntity {
  id: number
  legalName?: string | null
  tin?: string | null
  main?: boolean
  financeAccounts?: LedgerAccountFragment[]
  currency?: string | null
}

export interface FinancialDocumentAssociation {
  id?: number | null
  resource: FinanceFinancialDocumentResourceInput | null
}

export interface InvoiceForm {
  documentNumber: string
  totalAmountCents: string
  currency?: string
  documentDate?: string
  dueDate?: string
  taxes: Tax[]
  status: FinanceValueObjectsInvoiceStatusEnum
  vendor: ContactFragment | null
  legalEntity: LegalEntity | undefined | null
  associations?: FinancialDocumentAssociation[] | null
  ledgerAccountId: number | undefined
  validatedAt?: string
  documentType?: FinanceValueObjectsFinancialDocumentTypeEnum
  parentFinancialDocument?: FinancialDocumentForSelectFragment | null
}

export enum FinancialDocumentAssociationType {
  Project = 'project',
  Subproject = 'subproject',
  PurchaseOrder = 'purchaseorder',
  SoftwareSetup = 'softwaresetup',
  Expense = 'expense',
}
